import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials missing. Auth features will be disabled.')
}

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
      }
    })
  : null

// Subscription tiers
export const TIERS = {
  FREE: 'free',
  BASIC: 'basic',
  PRO: 'pro',
  ELITE: 'elite'
}

// Tier limits
export const TIER_LIMITS = {
  [TIERS.FREE]: {
    name: 'Free',
    price: 0,
    arbMaxPercent: 1.0,
    middlesAccess: false,
    evAccess: false,
    alertsPerDay: 5,
    refreshRate: 60,
    historicalDays: 7,
    propsAccess: false,
    modelAccess: false,
  },
  [TIERS.BASIC]: {
    name: 'Basic',
    price: 19,
    arbMaxPercent: 3.0,
    middlesAccess: true,
    evAccess: false,
    alertsPerDay: 50,
    refreshRate: 30,
    historicalDays: 30,
    propsAccess: true,
    modelAccess: false,
  },
  [TIERS.PRO]: {
    name: 'Pro',
    price: 49,
    arbMaxPercent: 100,
    middlesAccess: true,
    evAccess: true,
    alertsPerDay: 500,
    refreshRate: 10,
    historicalDays: 90,
    propsAccess: true,
    modelAccess: true,
  },
  [TIERS.ELITE]: {
    name: 'Elite',
    price: 99,
    arbMaxPercent: 100,
    middlesAccess: true,
    evAccess: true,
    alertsPerDay: -1,
    refreshRate: 5,
    historicalDays: 365,
    propsAccess: true,
    modelAccess: true,
    apiAccess: true,
    prioritySupport: true,
  }
}

export default supabase
